import { render } from "./BenefitTitle.vue?vue&type=template&id=2ca7edd9&scoped=true&ts=true"
import script from "./BenefitTitle.ts?vue&type=script&lang=ts&external"
export * from "./BenefitTitle.ts?vue&type=script&lang=ts&external"

import "./BenefitTitle.scss?vue&type=style&index=0&id=2ca7edd9&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca7edd9"]])

export default __exports__